export const COMMUNITY_CURATIONS_LIMIT = 12;
